import { Component, Input, OnInit } from '@angular/core'
import { FeatureService } from '@cms/services/feature.service'
import { IKetshopwebFrontendService, KetshopwebFrontendService } from '@cms/services/ketshopweb-frontend.service'
import { MenuListStore } from '@cms/store/MenuSetting'
import { ModalEditMenuComponent } from '@cms/system/modal/modal-edit-menu/modal-edit-menu.component'
import { NzMessageService, NzModalService } from 'ng-zorro-antd'
@Component({
  selector: 'ket-page-list',
  templateUrl: './page-list.component.html',
  styleUrls: ['./page-list.component.scss'],
})
export class KetPageListComponent implements OnInit {
  constructor(
    private ketshopwebFrontendService: KetshopwebFrontendService,
    private Service_Feature: FeatureService,
    private modal: NzModalService,
    private Servive_frontend: KetshopwebFrontendService,
    private message: NzMessageService,
  ) {}

  @Input() pagelist: any = []
  @Input() options2: any = {}

  disabled_group = false
  feature: any = {}
  select_index = -1
  message_duration = 4000
  
  readonly menuType = IKetshopwebFrontendService.MenuType
  MenuListStore = MenuListStore

  async ngOnInit() {
    this.feature.PRODUCT_PAGE = await this.Service_Feature.getFeature('PRODUCT_PAGE')
    this.feature.BLOG_PAGE = await this.Service_Feature.getFeature('BLOG_PAGE')
    // this.pagelist = await this.ketshopwebFrontendService.getMenuPageList()

    // await this.init(true)
  }

  async init(pagelist: boolean) {
    if (pagelist) {
      // this.pagelist = await this.Service_Front.getMenuPageList();
      this.pagelist = await this.ketshopwebFrontendService.getMenuPageList()
      for (let i = 0; i < this.pagelist.length; i++) {
        const current = this.pagelist[i]
        current.$$expanded = true
        current._checked = false
        current._disabled = false
        this.chekcFeature(current)
        for (let j = 0; j < current.childrens.length; j++) {
          const current2 = current.childrens[j]
          current2.$$expanded = true
          current2._checked = false
          current2._disabled = false
          this.chekcFeature(current2)
          for (let k = 0; k < current2.childrens.length; k++) {
            const current3 = current2.childrens[k]
            current3.$$expanded = true
            current3._checked = false
            current3._disabled = false
            this.chekcFeature(current3)
          }
        }
      }
      console.log(this.pagelist)
    }
  }
  
  chekcFeature(obj) {
    if (obj.page == 'Products' && !this.feature.PRODUCT_PAGE) {
      obj._disabled = true
    }
    if (obj.page == 'Blog' && !this.feature.BLOG_PAGE) {
      obj._disabled = true
    }
  }

  edit(data) {
    console.log(data)
    const modal = this.modal
      .create({
        nzTitle: 'แก้ไขเมนู',
        nzContent: ModalEditMenuComponent,
        nzStyle: { top: '20px' },
        nzWidth: '70%',
        nzKeyboard: false,
        nzMaskClosable: false,
        nzOnOk: (componentInstance) => {
          return componentInstance.ok()
        },
        nzOnCancel: (componentInstance) => {},
        nzComponentParams: {
          data: {
            page: data,
          },
        },
      })
      .afterClose.subscribe((result) => {
        modal.unsubscribe()
        if (result) {
          // this.init(true)
        }
      })
  }

  delete(obj) {
    this.modal.confirm({
      nzTitle: `Are you sure to delete menu ${obj.lang1} ?`,
      nzContent: '',
      nzOkText: 'Yes',
      nzOkType: 'danger',
      nzOnOk: () => {
        // this.Service_Front.deleteMenu(obj)
        $('.theme-loader').fadeIn()
        this.ketshopwebFrontendService.deleteMenu(obj.page_id).then((res: any) => {
          this.init(true)
          let state = MenuListStore.get()
          state = state.filter((x) => x.page_id != obj.page_id)
          MenuListStore.set(state)
          $('.theme-loader').fadeOut()
        }).catch((e) => {
          $('.theme-loader').fadeOut()
          this.message.error(e.error.message, { nzDuration: this.message_duration })
          return false
        })
      },
      nzCancelText: 'No',
      nzOnCancel: () => {},
    })
  }

  async onToggleEnable(data) {
    const modal_move = {
      page_id: data.page_id,
      enable: data.enable,
    }
    await this.Servive_frontend.toggleEnable(modal_move).catch((e) => {
      this.message.error(e.error.message, { nzDuration: this.message_duration })
      return false
    })
  }
}
